import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {SliceStatus, SSLInspectionStatus} from 'interfaces'
import {PoliciesState} from './policiesSlice'

function getPolicies(state: RootState): PoliciesState {
  return state.policies
}

export const selectPolicies = createSelector(getPolicies, policies => policies)
export const isDeleteStatusPending = createSelector(getPolicies, policies => {
  return policies?.deletePolicyStatus === SliceStatus.pending
})
export const selectShowCreatePolicyRP = createSelector(
  getPolicies,
  policies => policies?.showCreatePolicyRP,
)

// Return this SSL Inspection state from saved policy
export const selectSSLInspectionDisabledInSnapshot = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.snapshot === SSLInspectionStatus.DISABLED ||
    (sslInspectionState.snapshot === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.DISABLED),
)

// Return this SSL Inspection state from current working data
export const selectSSlInspectionEnabled = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.ENABLED ||
    (sslInspectionState.data === SSLInspectionStatus.BASE &&
      sslInspectionState.basePolicy === SSLInspectionStatus.ENABLED),
)

export const selectSSLInspectionInherited = createSelector(
  getPolicies,
  ({sslInspectionState}) =>
    sslInspectionState.data === SSLInspectionStatus.BASE,
)

export const selectSSLInspectionData = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.data,
)

export const selectSSLInspectionSnapshot = createSelector(
  getPolicies,
  ({sslInspectionState}) => sslInspectionState.snapshot,
)
